import * as React from "react";
import ErrorBoundary from "../../utils/ErrorBoundary";
import StartViewTile from "../../views/MainView/StartViewTile";

interface INavbarProps {
    label: string;
    imageSource: string;
    onClick: () => void;
    onDelete?: (link: string) => void;
    marginLeft?:string;
    data?:string;
    contextMenuUrl:string;
    isFromTop: boolean;
}

const NavLink = (props: INavbarProps): JSX.Element => (
    <div className='start-view-grid-column' style={{marginLeft:props.marginLeft}} data-cy={props.data}>
            <ErrorBoundary >
                <StartViewTile
                    label={props.label}
                    imageSource={props.imageSource}
                    labelColor='white'
                    onClick={props.onClick}
                    contextMenuUrl={props.contextMenuUrl}
                    isFromTop={props.isFromTop}
                />
            </ErrorBoundary>
    </div>
);

export default NavLink;



// WEBPACK FOOTER //
// ./src/components/NavLink/NavLink.tsx